






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class TopListCoupons extends Vue {
  @Prop() session!: string;
  @Prop() user_role!: string;
}
